import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {InsolesPatientSummaryModel} from './insolesPatientSummary.model';

@Injectable()
export class InsolesPatientSummaryConverter extends HttpModelConverter<InsolesPatientSummaryModel> {

    constructor() {
        super();
    }

    protected createInstance(): InsolesPatientSummaryModel {
        return new InsolesPatientSummaryModel();
    }

    protected enrichObject(result: InsolesPatientSummaryModel, src: InsolesPatientSummaryModel) {
    }

}
